import { useState } from "react";
import { useMediaTranscoding } from "@circle-react/hooks/useMediaTranscoding";
import type { MediaTranscoding } from "@circle-react/types/MediaTranscoding";
import type { VideoVariants } from "../types";

interface UseVideoSourceProps {
  mediaTranscoding?: MediaTranscoding;
  signedId?: string;
  sourcePreviewThumbnailsUrl?: string;
  sourceVariants?: VideoVariants;
  src: string;
}

export const useVideoSource = ({
  mediaTranscoding,
  signedId,
  src,
  sourceVariants,
  sourcePreviewThumbnailsUrl,
}: UseVideoSourceProps) => {
  const [playbackSrc, setPlaybackSrc] = useState(sourceVariants?.hls ?? src);
  const [previewThumbnailsUrl, setPreviewThumbnailsUrl] = useState(
    sourcePreviewThumbnailsUrl,
  );
  const isHls = playbackSrc.endsWith(".m3u8");

  useMediaTranscoding({
    enabled: !isHls || !previewThumbnailsUrl,
    signedId,
    mediaTranscoding,
    onSuccess: ({ hlsUrl, previewThumbnailsUrl: newPreviewThumbnailsUrl }) => {
      // Skip the playback source update if the current source is already HLS
      // to avoid unnecessary re-renders due to signed token changes in HLS URL
      if (hlsUrl && !isHls) {
        setPlaybackSrc(hlsUrl);
      }

      if (newPreviewThumbnailsUrl) {
        setPreviewThumbnailsUrl(newPreviewThumbnailsUrl);
      }
    },
  });

  return {
    playbackSrc,
    previewThumbnailsUrl,
    isHls,
  };
};
